import React from 'react'
import { Drawer } from 'antd'
import EditCategoryForm from './EditCategoryForm'
import { useDispatch } from 'react-redux'
import { rubricActions } from '../../../../../../store/slices/rubric.slice'

const EditCategoryDrawer = () => {
    const dispatch = useDispatch()

    const handleClose = () => dispatch(rubricActions.setEditingCategoryId(null))

    return (
        <Drawer title='Edit Category' autoFocus onClose={handleClose} open width={560} destroyOnClose zIndex={9000}>
            <EditCategoryForm onSuccess={handleClose} />
        </Drawer>
    )
}

export default EditCategoryDrawer
